import BaseService from "services/base";
import { builder } from "utils/graphql";
import { SHOP_STAFF_SELECTION } from "./constant";

class ShopStaffService extends BaseService {
  static override DEFINITION = builder.createDefinition({
    name: "ShopStaff",
    baseQuery: "ShopStaff",
    baseSelection: `
      ${SHOP_STAFF_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
    },
    GQL_ACTIONS: {
      FIND: "ShopStaffs",
      CREATE: "createShopStaff",
      UPDATE: "updateShopStaff",
      DELETE: "deleteShopStaff",
    },
    GQL_RESPONSE_DATA_PATH: {
      BASE: "data.ShopStaff",
      FIND: "data.ShopStaffs.docs",
      PARAMS: "data.ShopStaffs",
    },
  });
}
// export * from "./formatter";

const Instance = new ShopStaffService();
export default Instance;
